import React, { useState } from 'react';
import Box from '@mui/material/Box';
import acumaticaHelpers from '../../helpers/acumatica';
import AcumaticaApplyPaymentsForm from './AcumaticaApplyPaymentsForm';

function AcumaticaApplyPayments(props) {

    const [file, setFile] = useState(null);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState(false);
    const [fileData, setFileData] = useState(null);

    const buttonRef = React.createRef();
    const handleOpenDialog = (e) => {
        if (buttonRef.current) {
            buttonRef.current.open(e);
        };
    };

    const handleRemoveFile = (e) => {
        if (buttonRef.current) {
            buttonRef.current.removeFile(e);
            setFile(null);
        };
    };

    const headers = ["payment_ref", "invoice_number"];

    const downloadTemplate = async() => {
        const csv = headers;
        const blob = new Blob([csv], {type: "text/csv"});
        const uri = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.setAttribute("href", uri);
        a.setAttribute("download", "AcumaticaApplyPaymentsTemplate.csv");
        document.body.appendChild(a);
        a.click();
    };

    const formatUpload = (data) => {
        const dataArray = [];
        try {
            data.forEach(row =>{
                let d = row.data;
                const invoice = {
                    PaymentNbr: d.payment_ref,
                    InvoiceNbr: d.invoice_number
                };

                Object.entries(invoice).forEach(([key, value]) => {
                    if (value === undefined || value === "") {
                        throw new Error(`Missing required field: ${key}`);
                    };
                });
                dataArray.push(invoice);
            });
            return dataArray;
        } catch(err) {
            console.log(err);
            window.alert(err);
            return false;
        };
    };

    const handleOnFileLoad = (data, file) => {
        setFile(file);
        setSuccess(false);
        const formattedData = formatUpload(data);
        if(!formattedData) {
            setFile(null);
            return;
        };
        setFileData(formattedData);
    };

    const handleOnError = (err, file) => {
        console.log(err);
        setError(`Error Uploading Order File: ${file.name}`);
    };

    const uploadFile = async () => {
        props.setLoading(true);
        try {
            const body = {
                invoices: fileData
            };

            const res = await acumaticaHelpers.applyPayments(body, props.company, props.token);

            if (res.data.fail.length) {
                const failed_invoices = res.data.fail;
                return window.alert(`Successful Invoices: ${res.data.success.length}\nFailed Invoices: ${res.data.fail.length}\n\nFailed Invoice #s: ${failed_invoices.join(', ')}`);
            } else {
                return window.alert(`Successful Invoices: ${res.data.success.length || 0}\nFailed Invoices: ${res.data.fail.length || 0}`);
            };
        } catch (err) {
            console.log('uploadFile error: ', err);
        } finally {
            setFileData(null);
            setFile(null);
            props.setLoading(false);
        };
    };

    return (
        <Box display = "flex" flexDirection = "column" className = {props.isMobile ? "mobile-top" : "desktop-top"}>
            <Box className = {props.isMobile ? "mobile-box" : "desktop-box"} sx = {{paddingLeft: 3}}>
                <h1>Acumatica Apply Payments</h1> 
                <p>Submit one payment at a time.</p>
                <AcumaticaApplyPaymentsForm
                    file = {file}
                    setFile = {setFile}
                    company = {props.company}
                    token = {props.token}
                    user = {props.user}
                    warehouse = {props.warehouse}
                    toast = {props.toast}                 
                    loading = {props.isLoading}
                    downloadTemplate = {downloadTemplate}
                    handleOnFileLoad = {handleOnFileLoad}
                    handleOnError = {handleOnError}
                    uploadFile = {uploadFile}
                    handleOpenDialog = {handleOpenDialog}
                    handleRemoveFile = {handleRemoveFile}
                    buttonRef = {buttonRef}
                 />
            </Box>
        </Box>
    )
}

export default AcumaticaApplyPayments;